























import Component from 'vue-class-component';
import { Base } from '@/base';
import { Prop } from 'vue-property-decorator';

declare var Stripe: any;

@Component({
  name: 'stripe-component',
})
export default class StripeComponent extends Base {
  @Prop({ default: null }) element: any;

  stripe: any;
  elements: any;
  card: any;
  mountedElements: any[] = [];
  style = {
    iconStyle: 'solid',
    style: {
      base: {
        iconColor: '#c4f0ff',
        color: '#888',
        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
        fontSize: '14px',
        fontSmoothing: 'antialiased',

        ':-webkit-autofill': {
          color: '#fce883',
        },
        '::placeholder': {
          color: '#888',
        },
      },
      invalid: {
        iconColor: '#FF0000',
        color: '#FF0000',
      },
    },
  };

  error = {
    cardNumber: false,
    cardExpiry: false,
    cardCvc: false
  };

  mounted (): void {
    this.getStripePublicExt()
      .then(res => {
        this.stripe = Stripe(res.data);
        this.elements = this.stripe.elements();
        this.createElements();
        this.$store.commit('setSideBarFormSubmit', this.purchase.bind(this));
      });
    this.$watch('getOpenClose', (isOpen) => {
      if (!isOpen) {
        this.clearElements();
      } else {
        this.$store.commit('setSideBarFormSubmit', this.purchase.bind(this));
      }
    })
  }

  createElements (): void {
    const cardNumber = this.elements.create('cardNumber', this.style);
    cardNumber.mount('#card-number');
    const cardExpiry = this.elements.create('cardExpiry', this.style);
    cardExpiry.mount('#card-expiry');
    const cardCvc = this.elements.create('cardCvc', this.style);
    cardCvc.mount('#card-cvc');

    this.mountedElements = [
      cardNumber,
      cardExpiry,
      cardCvc
    ];
    this.validateFields();
  }

  purchase (data): void {
    this.stripe.createToken(this.elements.getElement('cardNumber'), {
      email: data[0],
      name: data[1]
    }).then((result) => {
      if (!result.error) {
        this.clearElements();
        this.purchaseStripeExt({
          email: data[0],
          fullName: data[1],
          amount: parseFloat(data[2]),
          token: result.token.id
        }).then(() => {
          this.openClose();
        }).catch((err) => {
          console.log(err);
        })
      }
    });
  }
  
  private validateFields() {
    this.mountedElements.forEach((element) => {
      element.on('change', e => {
        this.error[e.elementType] = !!e.error;
        this.element.hasError = Object.keys(this.error).some(key => this.error[key]);
      })
    })
  }

  clearElements() {
    this.mountedElements.forEach(element => element.clear());
  }

  destroyed (): void {
    this.clearElements();
  }
}
